import request from '@/config/axios'

export interface ActivityRecordVO {
  id?: number
  activityId?: number
  style?: string
  memberId?: number
  openid?: string
  nickname?: string
  requestId?: string
  playResult?: number
  costQuota?: number
  channel?: string
  playTime?: string
  createTime?: string
}

export interface ActivityRecordPageReqVO extends PageParam {
  activityId?: number
  memberId?: number
  nickname?: string
  playResult?: number
  requestId?: string
  playTime?: string[]
}

export const getActivityRecordPage = (params: ActivityRecordPageReqVO) => {
  return request.get({ url: '/promotion/activity-record/page', params })
}

/** 后端返回全量分页数据（PAGE_SIZE_NONE），前端自行转表 */
export const exportActivityRecord = (params: ActivityRecordPageReqVO) => {
  return request.get({ url: '/promotion/activity-record/export', params })
}
